module.exports = __webpack_public_path__ + "img/ic_help.5401d12c.svg";